@if (open) {
  <div class="app-popover opacity-hide" [class.opacity-show]="open" [ngClass]="positionClass">
    <ng-content></ng-content>
  </div>
}